<div *ngIf="second" class="text-white dow" [ngClass]="{'bg-danger': weekend, 'bg-primary': !weekend}">{{dow}}</div>
<div>
  <div class="text-primary bold">{{first}}</div>  
  <small *ngIf="second">{{second}}</small>
</div>
